// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"0e3cf0c1","144":"011693a8","462":"ff9f9964","539":"1c1dee89","558":"79d1ca08","738":"dd4785ad","864":"8035fb17"}[chunkId] + ".chunk.js";
};